
import React from "react";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";

const Paginations = (props) => {
  const data = props.data;

  // Prevent crash if pagination data is missing
  if (!data || data.from === undefined || data.from === null) {
    return null;
  }

  return (
    <div className="d-md-flex justify-content-between align-items-center">
      <span>
        Showing
        <span className="fw-700"> {data.from} </span>
        to
        <span className="fw-700"> {data.to ?? 0} </span>
        of
        <span className="fw-700"> {data.total ?? 0} </span>
        entries
        <br />
      </span>

      <span className="text-muted me-3">
        Show{" "}
        <select
          className=""
          value={localStorage.getItem("PerPage") || "15"}
          name="per_page"
          onChange={(e) => {
            localStorage.setItem("PerPage", e.target.value);

            if (typeof props.getTodayFollowup === "function") {
              props.getTodayFollowup("refresh");
            } else if (typeof props.perPage === "function") {
              props.perPage();
            }
          }}
        >
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>{" "}
        entries
      </span>

      <Pagination
        aria-label="Page navigation example"
        listClassName="paginationSm justify-content-end"
      >
        {props.local !== undefined ? (
          <>
            <PaginationItem disabled={data.prev_page_url == null}>
              <PaginationLink
                onClick={() => {
                  if (data.prev_page_url) {
                    props.paginate(data.prev_page_url);
                  }
                }}
              >
                Previous
              </PaginationLink>
            </PaginationItem>

            <PaginationItem disabled={data.next_page_url == null}>
              <PaginationLink
                onClick={() => {
                  if (data.next_page_url) {
                    props.paginate(data.next_page_url);
                  }
                }}
              >
                Next
              </PaginationLink>
            </PaginationItem>
          </>
        ) : (
          data.links?.map((item, i) => (
            <PaginationItem
              active={item.active}
              disabled={item.url == null}
              key={i}
            >
              <PaginationLink
                onClick={() => {
                  if (item.url) {
                    props.paginate(item.url);
                  }
                }}
              >
                {item.label}
              </PaginationLink>
            </PaginationItem>
          ))
        )}
      </Pagination>
    </div>
  );
};

export default Paginations;
